import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import  { Redirect } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import Navbar from '../components/Navbar/Navbar'
import { validateSession } from '../helpers';
import FoldersTable from '../components/Folders/FoldersTable'

const useStyles = makeStyles(() => ({
  main: {
    margin: '10% 5% 5% 5%',
    maxWidth: '90%',
  },
}));

export default function Folders() {
  const classes = useStyles();
  return (
    <>
      {!validateSession() ? <Redirect to="/login" /> : ''}
      <Navbar />
      <Grid container className={classes.main}>
        <Grid item xs={12}>
          <FoldersTable />
        </Grid>
      </Grid>
    </>
  );
}
